/*=========================================================================================
  File Name: moduleNaturalEntityGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  naturalEntity: state => {
    if (state.naturalEntity !== null) {
      return state.naturalEntity
    }
    return null
  },
  naturalEntityId: state => {
    if (state.naturalEntity !== null) {
      return state.naturalEntity.id
    }
    return null
  },
  peopleId: state => {
    if (!state.naturalEntity || !state.naturalEntity.pleople) {
      return null
    }
    return state.naturalEntity.pleople.id
  }
}
